'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _playlists = require('redux/modules/playlists');

var playlistsActions = _interopRequireWildcard(_playlists);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _FilterButton = require('components/FilterButton/FilterButton');

var _FilterButton2 = _interopRequireDefault(_FilterButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./PlaylistsSorter.scss');

var PlaylistsSorter = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    activeOrder: state.playlists.activeOrder,
    order: state.playlists.order,
    orders: state.playlists.orders
  };
}, (0, _extends3.default)({}, playlistsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(PlaylistsSorter, _Component);

  function PlaylistsSorter() {
    (0, _classCallCheck3.default)(this, PlaylistsSorter);
    return (0, _possibleConstructorReturn3.default)(this, (PlaylistsSorter.__proto__ || (0, _getPrototypeOf2.default)(PlaylistsSorter)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlaylistsSorter, [{
    key: 'reorder',
    value: function reorder(e) {
      var _props = this.props,
          reorder = _props.reorder,
          activeOrder = _props.activeOrder;

      var order = (0, _get3.default)(e, 'target.value', activeOrder);
      reorder(order);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          orders = _props2.orders,
          order = _props2.order,
          activeOrder = _props2.activeOrder;
      var t = this.context.t;

      var _t = t;

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'div',
          { className: (0, _bind2.default)(styles.sortTitle) },
          _react2.default.createElement(
            'span',
            { className: 'nowrap' },
            t('Sort by'),
            ':'
          )
        ),
        _react2.default.createElement(
          'span',
          { className: styles.sorterBlock },
          _react2.default.createElement(
            'select',
            { className: styles.orderSelect, onChange: this.reorder, value: activeOrder },
            orders.map(function (orderItem) {
              return _react2.default.createElement(
                'option',
                { key: orderItem.name, value: orderItem.name },
                _t(orderItem.title)
              );
            })
          ),
          _react2.default.createElement(_FilterButton2.default, {
            className: 'margin-left-5',
            onClick: this.reorder,
            iconClass: order[activeOrder] === 'asc' ? 'icon-sort-alpha-asc' : 'icon-sort-alpha-desc'
          })
        )
      );
    }
  }]);
  return PlaylistsSorter;
}(_react.Component), _class3.propTypes = {
  activeOrder: _propTypes2.default.string,
  order: _propTypes2.default.object,
  orders: _propTypes2.default.array,
  reorder: _propTypes2.default.func
}, _class3.contextTypes = {
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'reorder', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reorder'), _class2.prototype)), _class2)) || _class);
exports.default = PlaylistsSorter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlists/components/PlaylistsSorter/PlaylistsSorter.js
// module id = 2185
// module chunks = 1